import req from "../methods/req"
import method from '../methods/method'


// 规则配置列表
export const getList = function({
	_this,
	data = {}
}) {
	return method.get_list({
		_this,
		url: '/manage/station.rule/getList',
		data
	})
}



// 规则添加编辑
export const saveRuleInfo = function(data) {
	return req({
		url: '/manage/station.rule/saveRule',
		...data,
	})
}

// 获取规则详情
export const getRuleDetail = function(data) {
	return req({
		url: '/manage/station.rule/getDetail',
		...data,
	})
}

// 规则禁用启用
export const changeRuleStatus = function(data) {
	return req({
		url: '/manage/station.rule/changeStatus',
		...data,
	})
}
// 保存旺季配置
export const savePeakConfig = function(data) {
	return req({
		url: '/manage/station.rule/savePeakConfig',
		...data,
	})
}
// 获取旺季配置
export const getPeakConfig = function(data) {
	return req({
		url: '/manage/station.rule/getPeakConfig',
		...data,
	})
}
// 获取派驻工厂
export const getFactorySelect = function(data) {
	return req({
		url: '/manage/station.personnel/getFactorySelect',
		...data,
	})
}
// 获取派驻工厂
export const getFactoryRule = function(data) {
	return req({
		url: '/manage/station.personnel/getFactoryRule',
		...data,
	})
}
// 新增驻厂人员
export const addPersonnel = function(data) {
	return req({
		url: '/manage/station.personnel/addPersonnel',
		...data,
	})
}


// 驻厂人员列表
export const PersonnelList = function({
	_this,
	data = {}
}) {
	return method.get_list({
		_this,
		url: '/manage/station.personnel/getList',
		data
	})
}



// 编辑驻厂人员
export const editPersonnel = function(data) {
	return req({
		url: '/manage/station.personnel/editPersonnel',
		...data,
	})
}

// 获取驻厂人员详情
export const personnelDetail = function(data) {
	return req({
		url: '/manage/station.personnel/getDetail',
		...data,
	})
}

// 结束驻厂
export const endPersonnel = function(data) {
	return req({
		url: '/manage/station.personnel/endPersonnel',
		...data,
	})
}
// s删除驻厂
export const delPersonnel = function(data) {
	return req({
		url: '/manage/station.personnel/delPersonnel',
		...data,
	})
}


// 规则删除
export const delRule = function(data) {
	return req({
		url: '/manage/station.personnel/getDetail',
		...data,
	})
}





// 日报表详情
export const getDetail = function(data) {
	return req({
		url: '/manage/station.report/getDayDetail',
		...data,
	})
}

// day头部统计
export const getDayCount = function(data) {
	return req({
		url: '/manage/station.report/getDaySummary',
		...data,
	})
}
// month头部统计
export const getMonthCount = function(data) {
	return req({
		url: '/manage/station.report/getMonthSummary',
		...data,
	})
}
//补卡
export const supplementClock = function(data) {
	return req({
		url: '/manage/station.report/supplementClock',
		...data,
	})
}

//打卡详情
export const getDayDetail = function(data) {
	return req({
		url: '/manage/station.report/getDayDetail',
		...data,
	})
}






// 获取日报表列表
export const getDayList = function({
	_this,
	data = {}
}) {
	return method.get_list({
		_this,
		url: '/manage/station.report/getDayList',
		data
	})
}
// 获取月报表列表
export const getMonthList = function({
	_this,
	data = {}
}) {
	return method.get_list({
		_this,
		url: '/manage/station.report/getMonthList',
		data
	})
}
// 人员选择
export const getUserSelect = function(data) {
	return req({
		url: '/manage/crm.common/getUserSelect',
		...data,
	})
}
// 删除分管领导
export const delLeader = function(data) {
	return req({
		url: '/manage/station.leader/del',
		...data,
	})
}
// 驻厂分管领导列表
export const getUserList = function({
	_this,
	data = {}
}) {
	return method.get_list({
		_this,
		url: '/manage/station.leader/getList',
		data
	})
}


// 保存驻厂分管领导
export const saveConfig = function(data) {
	return req({
		url: '/manage/station.leader/save',
		...data,
	})
}




//详情
export const getUserDetail = function(data) {
	return req({
		url: '/manage/sink_frontline.config/getUserDetail',
		...data,
	})
}

//删除
export const delConfig = function(data) {
	return req({
		url: '/manage/sink_frontline.config/delConfig',
		...data,
	})
}
//月度明细
export const getMonthDetail = function(data) {
	return req({
		url: '/manage/station.report/getMonthDetail',
		...data,
	})
}


//月统计-分类明细
export const getMonthTypeDetail = function(data) {
	return req({
		url: '/manage/station.report/getMonthTypeDetail',
		...data,
	})
}




//月统计-导出
export const exportMonthDetail = function(data) {
	return req({
		url: '/manage/station.report/exportMonthDetail',
		...data,
	})
}

//获取可补卡时间
export const getSupplementTimes = function(data) {
	return req({
		url: '/manage/station.report/getSupplementTimes',
		...data,
	})
}




